<template> 
  <v-card class="mx-auto" width="600">
    <v-app-bar color="accent" dark rounded flat>
      <v-toolbar-title>{{ form.title }}</v-toolbar-title>
    </v-app-bar>
    <v-card-text>
      <v-form ref="group_job_form">
        <v-text-field v-model="groupJob.jobName" :counter="15" label="ジョブ名" 
          :rules="[rules.required, rules.max15]">
        </v-text-field>
        <v-textarea v-model="groupJob.jobOverview" :counter="50" label="概要" :rules="[rules.required, rules.max50]">
        </v-textarea>
        <v-slider 
          v-model="groupJob.jobTargetTotalCount" 
          class="mt-5" min="1" max="1000" 
          label="目標合計回数" 
          hint="参加メンバーで実施する回数の合計が目標となります" 
          thumb-label
          :rules="[rules.required]"
          :disabled="!enableEditSchedule">
        </v-slider>
          <v-combobox 
            v-model="groupJob.categoryList" 
            label="カテゴリー" 
            item-value="id" 
            item-text="name" 
            :items="this['category/categoryList']" 
            hide-selected  
            return-object 
            dense 
            hint="最大3つのカテゴリーを選択できます"
            :rules="[rules.required]"
            multiple 
            small-chips
            persistent-hint>
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    一致する結果がありません。 <kbd>Enter</kbd>を押して新しいカテゴリーを作成してください。 
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-combobox>

        <v-row>
          <v-col cols="6">
            <v-menu 
              v-model="startdateMenu" 
              :close-on-content-click="false" 
              :nudge-right="40" 
              transition="scale-transition" 
              offset-y>
              <template v-slot:activator="{ on }">
                <v-text-field 
                  v-model="groupJob.startDate" 
                  label="開始日" 
                  v-on="on" 
                  :value="dispStartDate" 
                  :rules="[rules.required]"
                  :disabled="!enableEditSchedule">
                </v-text-field>
              </template>
              <v-date-picker 
                v-model="groupJob.startDate" 
                :min="minStartDate" 
                :max="maxStartDate" 
                no-title 
                @input="selectStartDate">
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="6">
            <v-menu 
              v-model="finishdateMenu" 
              :close-on-content-click="false" 
              :nudge-right="40" 
              transition="scale-transition" 
              offset-y>
              <template v-slot:activator="{ on }">
                <v-text-field 
                  v-model="groupJob.finishDate" 
                  label="終了日" 
                  v-on="on" 
                  :value="dispFinishDate" 
                  :rules="[rules.required]"
                  :disabled="!enableEditSchedule"
                  >
                </v-text-field>
              </template>
              <v-date-picker 
                v-model="groupJob.finishDate" 
                :min="minFinishDate" 
                :max="maxFinishDate" 
                no-title   
                @input="selectFinishDate">
              </v-date-picker>
            </v-menu>           
          </v-col>
        </v-row>
        <div class="text-right">
          <!-- <v-btn @click="$emit('close')" color="secondary" outlined class="ml-2">閉じる</v-btn> -->
          <v-btn @click="toggleGroupJobFormModal" color="secondary" outlined class="ml-2">閉じる</v-btn>
          <v-btn @click="submit" color="accent" class="ml-2">{{ form.buttonText }}</v-btn>
        </div>
      </v-form>
    </v-card-text>
  </v-card>
</template>
<script>
import moment from "moment";
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    // group: Object,
    editGroupJob: Object,
    form: {
      title: String,
      subTitle: String,
      buttonText: String
    },
  },
  created(){
    // 編集用のジョブが渡った場合はdataに反映する
    if(this.editGroupJob){
      this.groupJob = this.editGroupJob;
    }
    this['category/fetchCategories']()
    
  },
  data (){
    return {
      rules: {
       required: v => !!v || '必須', 
       max15: v => (v || '').length <= 15 || '最大15文字',
       max50: v => (v || '').length <= 50 || '最大50文字',
       min1: v => v >= 1 || '1回以上'
      },
      startdateMenu: false,
      finishdateMenu: false,
      minStartDate: moment().format("YYYY-MM-DD"),
      maxStartDate: moment().add(2, 'months').format("YYYY-MM-DD"),
      minFinishDate: moment().add(1, 'months').add(1, 'days').format("YYYY-MM-DD"),
      maxFinishDate: moment().add(3, 'months').format("YYYY-MM-DD"),
      groupJob: {
        startDate: this.minStartDate,
        finishDate: this.minFinishDate,
        categoryList: []
      }
    }
  },
  computed: {
    dispStartDate() {
      return this.groupJob.startDate? this.groupJob.startDate : '';
    },
    dispFinishDate() {
      return this.groupJob.finishDate? this.groupJob.finishDate : '';
    },
    enableEditSchedule(){
      if(this.groupJob.jobId) {
        return moment(this.groupJob.startDate) > moment()
      }
      else {
        return true;
      }
    },
    ...mapGetters(['loginUserId','category/categoryList','group']),
  },
  watch: {
    // ジョブ開始日が空白になった場合は日付制約をリセットする
    'groupJob.startDate'(){
      if(''===this.groupJob.startDate){
        this.resetDateValidation();
      }
    },
    // ジョブ終了日が空白になった場合は日付制約をリセットする
    'groupJob.finishDate'(){
      if(''===this.groupJob.finishDate){
        this.resetDateValidation();
      }
    },
    'groupJob.categoryList'() {
      if (this.groupJob.categoryList.length > 3) {
        this.$nextTick(() => this.groupJob.categoryList.pop())
      }
    },
    // 編集用のグループジョブをフォームに反映する
    editGroupJob(){
      const editGroupJob = this.editGroupJob;
      if(editGroupJob.jobId){
        this.groupJob = editGroupJob;
      } else{
        this.groupJob = {}
        this.$refs.group_job_form.resetValidation()
      }
    }
  },
  methods: {
    selectStartDate(){
      const startDate = moment(this.groupJob.startDate);
      const finishDate = moment(this.groupJob.finishDate);
      this.startdateMenu = false;
      this.minFinishDate = startDate.add(1, 'months').add(1, 'days').format('YYYY-MM-DD'); 
      this.maxFinishDate = startDate.add(3, 'months').format('YYYY-MM-DD'); 
      if(!finishDate.isBetween(this.minFinishDate, this.maxFinishDate)) this.groupJob.finishDate = '';
    },
    selectFinishDate(){
      const startDate = moment(this.groupJob.startDate);
      const finishDate = moment(this.groupJob.finishDate);
      this.finishdateMenu = false;
      this.maxStartDate = finishDate.subtract(1, 'months').format('YYYY-MM-DD');
      if(!startDate.isBefore(this.maxStartDate)) this.groupJob.startDate = '';
    },
    resetDateValidation(){
      this.minStartDate = moment().format("YYYY-MM-DD");
      this.maxStartDate = moment().add(2, 'months').format("YYYY-MM-DD");
      this.minFinishDate = moment().add(1, 'months').add(1, 'days').format("YYYY-MM-DD");
      this.maxFinishDate = moment().add(3, 'months').format("YYYY-MM-DD");
    },
    submit(){
      if (this.$refs.group_job_form.validate()){
        // ジョブIDがなければ新しくジョブを登録する
        if(!this.groupJob.jobId){
          if(this.group.groupLeaderData.userId !== this.loginUserId) return
          this.groupJob.groupId = this.group.groupId;
          this.groupJob.jobStatus = 1;
          this['job/addMyJob'](this.groupJob);
        } else {
          this['job/updateMyJob'](this.groupJob);
        }
        // モーダルを閉じる
        this.toggleGroupJobFormModal();
        this.groupJob =  {
          startDate: this.minStartDate,
          finishDate: this.minFinishDate,
          categoryList: []
        }
      } 
      return
    },
    ...mapActions(['toggleGroupJobFormModal','job/addMyJob', 'job/updateMyJob','category/fetchCategories'])
  }
}
</script>